var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "reportDialog" }, [
    _vm.$route.query.report == 1
      ? _c("div", { staticClass: "btn", on: { click: _vm.open } }, [
          _vm._v(" 📊 " + _vm._s(_vm.$t("ConsultationReport")) + " "),
        ])
      : _vm._e(),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showDialog,
            expression: "showDialog",
          },
        ],
        staticClass: "main-dialog",
      },
      [
        _c("div", { staticClass: "home" }, [
          _c(
            "div",
            { staticClass: "top-box" },
            [
              _c("p", [
                _c("span", [_vm._v(" 📊 " + _vm._s(_vm.$t("Personalized")))]),
              ]),
              _c("a-icon", {
                staticClass: "icon",
                attrs: { type: "close-circle" },
                on: { click: _vm.close },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "main-box" }, [
            _c("iframe", {
              staticClass: "frame",
              style: { height: _vm.maxWindowHeight + "px" },
              attrs: { id: "myframe" },
            }),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }